/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum QPChatState {
  GOOD = "GOOD",
  CONTEXT_WINDOW_EXCEEDED = "CONTEXT_WINDOW_EXCEEDED",
}

export const QPChatStateDisplay: Record<QPChatState, string> = {
  [QPChatState.GOOD]: "Good",
  [QPChatState.CONTEXT_WINDOW_EXCEEDED]: "Context Window Exceeded",
};
